function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { toast } from "sonner";
import { SIcon } from "../../components";
const actionIconMap = {
    "open-url": "open",
    close: "x",
    restore: "refresh",
    "custom-in-app": "play",
    "custom-placement": "bolt",
    purchase: "checkout",
    "set-product-index": "product",
    "set-state": "code"
};
export const sonner = _object_spread_props(_object_spread({}, toast), {
    propertyAction: (action, options)=>{
        var _options_referenceNames;
        var _options_iconType;
        const iconType = (_options_iconType = options === null || options === void 0 ? void 0 : options.iconType) !== null && _options_iconType !== void 0 ? _options_iconType : "brand";
        const isEditor = iconType === "action";
        return toast(/*#__PURE__*/ _jsxs("div", {
            style: _object_spread({
                display: "flex",
                alignItems: "center",
                gap: 12
            }, options === null || options === void 0 ? void 0 : options.style),
            children: [
                /*#__PURE__*/ _jsx(SIcon, {
                    type: iconType === "brand" ? "logo-color" : actionIconMap[action.type],
                    className: iconType === "action" ? "text-brand-primary" : undefined,
                    size: iconType === "action" ? 16 : undefined
                }),
                /*#__PURE__*/ _jsxs("span", {
                    children: [
                        "Tap triggered a",
                        " ",
                        /*#__PURE__*/ _jsx(ToastPill, {
                            isEditor: isEditor,
                            margins: {
                                right: true
                            },
                            children: action.type
                        }),
                        action.type === "purchase" ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                "for",
                                action.reference.type === "by-index" ? /*#__PURE__*/ _jsx(ToastPill, {
                                    isEditor: isEditor,
                                    margins: {
                                        left: true
                                    },
                                    children: (options === null || options === void 0 ? void 0 : (_options_referenceNames = options.referenceNames) === null || _options_referenceNames === void 0 ? void 0 : _options_referenceNames[action.reference.index]) || 'unknown'
                                }) : /*#__PURE__*/ _jsx(ToastPill, {
                                    isEditor: isEditor,
                                    margins: {
                                        left: true
                                    },
                                    children: "selected"
                                })
                            ]
                        }) : /*#__PURE__*/ _jsx(_Fragment, {
                            children: "action"
                        }),
                        "."
                    ]
                })
            ]
        }));
    }
});
const ToastPill = ({ children, isEditor, margins })=>{
    return /*#__PURE__*/ _jsx("span", {
        style: {
            display: "inline-block",
            padding: isEditor ? "2px 6px" : "4px 6px",
            backgroundColor: "rgba(116, 255, 241, 0.15)",
            borderRadius: 7,
            color: "#74FFF1",
            textAlign: "center",
            marginRight: margins.right ? 4 : 0,
            marginLeft: margins.left ? 4 : 0
        },
        children: children
    });
};
